import React, { useEffect, useState } from "react";
import Layout, { PageHeader } from "../components/Layout";
import api, { formatApiError } from "../lib/api";
import StatusBadge from "../components/StatusBadge";
import { Card } from "../components/ui/card";
import { toast } from "sonner";

const variantFor = (s) =>
  s === "success" ? "success" : s === "partial" ? "warning" : s === "failure" ? "danger" : "default";

const ACTION_LABEL = {
  login: "Login",
  login_failed: "Login failed",
  settings_updated: "Settings updated",
  domains_refresh: "Domains synced",
  bulk_dns_change: "Bulk DNS change",
  ai_suggest: "AI suggestions",
  domain_purchase: "Domain purchase",
};

export default function Logs() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/activity-logs");
        setItems(data.items || []);
      } catch (e) {
        toast.error(formatApiError(e.response?.data?.detail));
      } finally { setLoading(false); }
    })();
  }, []);

  return (
    <Layout>
      <PageHeader eyebrow="Audit" title="Activity Logs" description="Every admin action and API outcome, in chronological order." />
      {loading ? <div className="overline">Loading…</div> : (
        <Card className="p-0 overflow-hidden" data-testid="logs-card">
          <table className="w-full text-sm">
            <thead className="bg-muted/40">
              <tr className="text-left">
                <th className="px-4 py-3 overline">Time</th>
                <th className="px-4 py-3 overline">Action</th>
                <th className="px-4 py-3 overline">Actor</th>
                <th className="px-4 py-3 overline">Targets</th>
                <th className="px-4 py-3 overline">Status</th>
                <th className="px-4 py-3 overline">Details</th>
              </tr>
            </thead>
            <tbody>
              {items.length === 0 ? (
                <tr><td colSpan={6} className="px-4 py-10 text-center text-muted-foreground">No logs yet.</td></tr>
              ) : items.map((log) => (
                <tr key={log.id} className="border-t border-border table-row-hover" data-testid={`log-${log.id}`}>
                  <td className="px-4 py-2 text-xs font-mono text-muted-foreground whitespace-nowrap">
                    {new Date(log.created_at).toLocaleString()}
                  </td>
                  <td className="px-4 py-2 text-sm font-medium">{ACTION_LABEL[log.action_type] || log.action_type}</td>
                  <td className="px-4 py-2 text-xs font-mono">{log.actor}</td>
                  <td className="px-4 py-2 text-xs font-mono text-muted-foreground">
                    {(log.target_domains || []).slice(0, 3).join(", ")}
                    {log.target_domains?.length > 3 && ` +${log.target_domains.length - 3}`}
                  </td>
                  <td className="px-4 py-2">
                    <StatusBadge variant={variantFor(log.status)}>{log.status}</StatusBadge>
                  </td>
                  <td className="px-4 py-2 text-xs text-muted-foreground max-w-sm truncate">
                    {log.error_message || JSON.stringify(log.payload_summary || {}).slice(0, 80)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      )}
    </Layout>
  );
}
